import React from 'react';

import logo from '../../images/logo.png';

export const FooterLogo = () => {

  return(
    <div>
      <div className="d-flex align-items-center">
        <img src={ logo } alt="Green Garden" className="footer-logo" />
        <span className="footer-text">Garden</span>
      </div>
      <p className="info info--xs mt-1">We are outdoor living and garden design company focussed on creating impeccable outdoor living spaces for home owners and businesses.</p>
    </div>
  );

}